export { default } from "./InsightsErrorPage";
